import { AfterViewChecked, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ThemeService } from '../../services/theme.service';
import { TranslationSyncService } from '../../services/translation-sync.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-privacy-policy',
  imports: [],
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.css'
})
export class PrivacyPolicyComponent implements OnInit, AfterViewChecked {

  isDarkMode: boolean;
  darkContainer: HTMLElement;
  @ViewChild('privacyPage', { static: false }) containerRef!: ElementRef<HTMLElement>;

  constructor(
    private themeService: ThemeService
  , private sync: TranslationSyncService
  ,public translate: TranslateService) { }


  ngAfterViewChecked(): void {
    this.registerAll(this.containerRef.nativeElement);
    this.darkContainer = document.getElementById('dark-container-privacyPolicyOverlay') as HTMLElement;

    // für data-transfe bei spracheinstellung
    this.registerAll(this.containerRef.nativeElement);
    this.registerAll(this.darkContainer);

  }

  ngOnInit(): void {
    this.themeService.isDarkMode$.subscribe(mode => {
      this.isDarkMode = mode;
      Promise.resolve().then(() => {
        const triggeredByToggle = this.themeService.wasThemeToggled();
      });
    });

  }

  private registerAll(root: HTMLElement) {
    const elems = Array.from(root.querySelectorAll<HTMLElement>('[data-translate]'));
    elems.forEach(el => {
      const key = el.getAttribute('data-translate')!;
      this.sync.register(el, key);
    });
  }

}
